import WarningIcon from "@mui/icons-material/Warning";
import { STRINGS_EN } from "../../../../constant";
import { setItem } from "../../../../utils/localStorage";
import { keys } from "../../../../constant/keyConfig";
import { getVendorUrl } from "../../../../utils/getVendorUrl";
import UpdateSelectedNewUser from "../UpdateSelectedNewUser.js";
import ConcurrentWarning from "../ConcurrentWarning/index.js";
import { isUserFromList } from "../../../../utils/isUserFromList.js";
import { getMappedEnvironment } from "../../../../utils/mapEnvironment.js";
import {
  createAddobjectId,
  getEnvironmentPart,
  getSelectedSetupUrl,
  getSelectedTenant,
} from "../../../../utils/getEnvDetails.js";

function NoEntryExit({ email }) {
  const domainstring =
    getEnvironmentPart() || process.env.REACT_APP_DEFAULT_ENV;
  const selectedEnv = getMappedEnvironment(domainstring);
  const selectedSetupUrl = getSelectedSetupUrl(domainstring);
  const selectedTenant = getSelectedTenant();
  const aadObjectId = createAddobjectId();
  const contextInfo = { email, aadObjectId };

  // updateTeamsContext(contextInfo);
  setItem(keys.TEAMS_CONTEXT_KEY, contextInfo);
  const environment = {
    selectedEnv,
    selectedSetupUrl: getVendorUrl(selectedSetupUrl),
    selectedTenant,
  };

  if (isUserFromList(email)) {
    return (
      <ConcurrentWarning
        message={STRINGS_EN.MST_first_time_user_send_teams}
        anotherAccount={true}
        iconName={<WarningIcon sx={{ fontSize: 50, color: "#f44336" }} />}
      />
    );
  }

  return (
    <>
      {email &&
      aadObjectId &&
      environment.selectedEnv &&
      environment.selectedSetupUrl &&
      environment.selectedTenant ? (
        <UpdateSelectedNewUser
          environment={environment}
          aadObjectId={aadObjectId}
          addAccountEmail={email}
        />
      ) : (
        <ConcurrentWarning
          message={STRINGS_EN.MST_unable_to_find_zycus_acc}
          notContactUs={true}
          iconName={<WarningIcon sx={{ fontSize: 50, color: "#f44336" }} />}
        />
      )}
    </>
  );
}

export default NoEntryExit;
